import type { Document, TopLevelBlock } from '@contentful/rich-text-types';
import type { CmsPageCollectionItems } from '$cms/types';
import { replaceHeadings } from '@/components/organisms/ExpertInsights/utils';
import { prepareCollectionsRichTextContent } from '../prepareCollectionsRichTextContent';

/**
 * Get all the CMS un-rendered blocks with headings starting from H3.
 */
export const getTopLevelBlocks = (
  collectionItems?: CmsPageCollectionItems,
  richTextContent?: Document
): TopLevelBlock[] => {
  const collectionItemsOrRichText = richTextContent || collectionItems;
  if (!collectionItemsOrRichText) return [];
  return replaceHeadings(prepareCollectionsRichTextContent(collectionItemsOrRichText));
};
